import React, { useRef, useState, useContext } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonHeader, IonContent, IonGrid, IonRow, IonCol, IonText, IonFooter, IonTextarea, IonToolbar, IonTitle, IonButtons} from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export function JobDescriptionModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [requisition_id, setRequisition_id] = useState(props.data.requisitionID);
    let [requisition_name, setRequisition_name] = useState(props.data.requisitionName);
    let [jobResponsibilites, setJobResponsibilites] = useState(props.data.requisitionResponsibilites);
    let [applicantQualifications, setApplicantQualifications] = useState(props.data.requisitionQualifications);
    let [applicantDeadline, setApplicantDeadline] = useState(props.data.requisitionDeadline);

    let [showApplicationSubmissionnModal, setShowApplicationSubmissionnModal] = useState(false);


        function updateJobRequisition()
    {
        /*
        let formData = new FormData();
        formData.append('Tracker', 74125);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '00_update_job_post',
                user: acctID,
                fmc_schema: schema,
                xJobRequisitionID: requisition_id,
                xRequisitionResponsibilities: jobResponsibilites,
                xRequisitionQualifications: applicantQualifications,
                xRequisitionDeadlineDate: applicantDeadline,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader> 
                <IonToolbar>
                <IonTitle>{"REQ ID: "+requisition_id+" - "+requisition_name}</IonTitle>
                <IonButtons slot="end">
                    <IonButton fill="outline" color="success" onClick={closeModalHandler}>Close</IonButton>
                </IonButtons>
                </IonToolbar>
                <IonGrid>
                    <IonRow>
                         <IonCol size='6'>
                           Deadline: <IonInput className='professional-input' type='text' value={applicantDeadline} placeholder='Enter First Name' autocomplete='off' onIonChange={(e) => setApplicantDeadline(e.target.value)} required></IonInput>
                        </IonCol>
                    </IonRow>
                </IonGrid > 
            </IonHeader>

            <IonContent className='grid_content'>
            <IonGrid>
                <IonRow>
                <IonCol size="12">
                    <h3>Responsibilities</h3>
                </IonCol>
                </IonRow>
                <IonRow>
                <IonCol>
                    <textarea
                    className="professional-textarea"
                    value={jobResponsibilites}
                    onChange={(e) => setJobResponsibilites(e.target.value)}
                    rows={16}
                    />
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol size="12">
                    <h3>Qualifications</h3>
                </IonCol>
                </IonRow>
                <IonRow>
                <IonCol>
                    <textarea
                    className="professional-textarea"
                    value={applicantQualifications}
                    onChange={(e) => setApplicantQualifications(e.target.value)}
                    rows={16}
                    />
                </IonCol>
                </IonRow>
            </IonGrid>
            </IonContent>
            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => updateJobRequisition()}>SAVE </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>

        </IonModal>
        ) : null}
    </React.Fragment>
    )
}
